import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CondutorModule } from '../condutor/condutor.module';
import { 
    BeneficiariaComponent,
    BeneficiariaService,
    ViewBeneficiariaComponent,
    FormBeneficiariaComponent,
    DetailBeneficiariaComponent
} from '.';
import { ViewBeneficiariaColigadaComponent } from './view-beneficiaria-coligada/view-beneficiaria-coligada.component';
import { FormBeneficiariaColigadaComponent } from './form-beneficiaria-coligada/form-beneficiaria-coligada.component';

@NgModule({
    declarations: [
        BeneficiariaComponent,
        ViewBeneficiariaComponent,
        FormBeneficiariaComponent,
        DetailBeneficiariaComponent,
        ViewBeneficiariaColigadaComponent,
        FormBeneficiariaColigadaComponent,
    ],
    imports: [
        SharedModule,
        CondutorModule
    ],
    providers: [
        BeneficiariaService,
    ]
})
export class BeneficiariaModule { }
